import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { BrowserPageTitle } from '../../../shared/constants/browser-page-title.enum';

import { OrderExceptionsPage } from './order-exceptions.page';
import { OrderExceptionsRouteGuard } from './route-guards/order-exceptions-route.guard';

const routes: Routes = [
  {
    path: '',
    canDeactivate: [OrderExceptionsRouteGuard],
    component: OrderExceptionsPage,
    data: { title: BrowserPageTitle.orderException },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), IonicModule],
  exports: [RouterModule],
})
export class OrderExceptionsPageRoutingModule {}
